import { TransactionMasterData } from "types/models/transactionMaster/TransactionMasterApp";


export const GET_TRANSATION = "GET_TRANSATION";
export const SET_TRANSATION_DATA = "SET_TRANSATION_DATA";
export const CREATE_TRANSATION = "CREATE_TRANSATION";
export const RESET_TRANSATION_DATA = "RESET_TRANSATION_DATA";

export const UPDATE_TRANSATION = "UPDATE_TRANSATION";

export interface GetTransactionAction {
  type: typeof GET_TRANSATION;
  payload: { data: TransactionMasterData[]; total: number };
}

export interface SetTransactionDetailAction {
  type: typeof SET_TRANSATION_DATA;
  payload: TransactionMasterData;
}
export interface createTransaction{
  type: typeof CREATE_TRANSATION;
    payload: any; 
}
export interface updateTransaction{
  type: typeof UPDATE_TRANSATION;
    payload: any; 
}
export interface ResetTransaction{
  type: typeof RESET_TRANSATION_DATA;
}

export type TransactionMasterActionTypes =
  | GetTransactionAction
  | SetTransactionDetailAction
  | createTransaction
  |updateTransaction
  |ResetTransaction
